import { useState, useCallback, useEffect } from 'react';
import { SuggestionMenuPositions } from '../types/index.js';

const isWindow = typeof window === 'object';
const defaultContextPosition = {
    x: 0, y: 0, z: 0, width: 0,
};
const defaultRect = {
    left: 0, width: 0, bottom: 0, top: 0, right: 0,
};
const useSuggestionMenu = (relativeRef, isOpen, position) => {
    const parent = relativeRef?.current;
    const [contextHeight, setContextHeight] = useState(0);
    const [contextPosition, setContextPosition] = useState(defaultContextPosition);
    const setPosition = useCallback(() => {
        const { width, left, right, bottom, top, } = parent ? parent.getBoundingClientRect() : defaultRect;
        setContextPosition({
            x: left, y: position === SuggestionMenuPositions.Bottom ? bottom : top - contextHeight, z: right, width,
        });
    }, [contextHeight, parent, position]);
    useEffect(() => {
        const handleScrollResize = () => {
            requestAnimationFrame(setPosition);
        };
        setPosition();
        if (parent && isOpen) {
            document.addEventListener('scroll', handleScrollResize);
            isWindow && window.addEventListener('resize', handleScrollResize);
            return () => {
                document.removeEventListener('scroll', handleScrollResize);
                isWindow && window.removeEventListener('resize', handleScrollResize);
            };
        }
    }, [isOpen, parent, setPosition]);
    return {
        contextPosition, setContextHeight, contextHeight, recalculatePosition: setPosition,
    };
};

export { useSuggestionMenu };
